import { LocationPinIcon } from "@/assets/icons/svg-icons";
import { ExpandableAvatar } from "@/components/expandable-avatar";
import { type ProfileViewModel } from "@/lib/types";
import { getInitials } from "@/lib/utils";
import { ShieldCheck } from "lucide-react";

interface ProfileHeaderProps {
  profile: Pick<
    ProfileViewModel,
    "FullName" | "City" | "State" |"Country" | "Image" | "ImageExtraLarge" | "ImageHash"
  >;
  label?: string;
}

const ProfileHeader = ({ profile, label }: Readonly<ProfileHeaderProps>) => {
  const initials = getInitials(profile?.FullName);
  const location = [profile?.City, profile?.Country].filter(Boolean).join(", ");

  return (
    <>
      {label && (
        <div className="flex justify-start sm:justify-end">
          <div className="flex items-center gap-1.5 text-muted-foreground">
            <ShieldCheck className="size-3.5" aria-hidden="true" />
            <span className="text-xs font-medium tracking-widest uppercase">
              {label}
            </span>
          </div>
        </div>
      )}

      <div className="flex items-center gap-3">
        <ExpandableAvatar
          src={profile.ImageExtraLarge}
          imageHash={profile.ImageHash}
          name={profile.FullName}
          initials={initials}
        />

        <div className="flex   min-w-0 flex-col  gap-0.5">
          <h2 className="text-xl leading-tight  font-medium text-black">
            {profile.FullName}
          </h2>
          <div className="flex  flex-col flex-wrap  items-start gap-x-3 gap-y-1 text-xs sm:flex-row">
            {location && (
              <span className="flex items-center gap-0.5">
                <LocationPinIcon
                  className="size-3 shrink-0"
                  aria-hidden="true"
                />
                {location}
              </span>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileHeader;
